enum PartyListTabs {
  waitlist = 'waitlist',
  walkIn = 'walkIn',
  expected = 'expected',
  seated = 'seated',
  finished = 'finished',
}

export enum PartyListMetaSections {
  upcoming = 'upcoming',
  walkins = 'walkins',
  noShows = 'noShows',
  cancellations = 'cancellations',
}

export default PartyListTabs;
